import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import { useTheme } from '@material-ui/core/styles';

import IAdd from '@meronex/icons/fi/FiPlusCircle';
import IEdit from '@meronex/icons/fi/FiEdit2';
import IDelete from '@meronex/icons/fi/FiTrash2';
import ICheck from '@meronex/icons/fi/FiCheckCircle';
import MdClose from '@meronex/icons/md/MdClose';

import SitesAvatar from '../../../common/SitesAvatar';

function ItemTypeActionsDialog(props) {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const {
    onAdd,
    onEdit,
    onDelete,
    store,
    enableAddToStore,
    open,
    onClose,
    itemType,
  } = props;

  let added = false;
  if (store && Array.isArray(itemType.addedToStores)) {
    added = itemType.addedToStores.includes(store._id);
  }

  const mutedColor = isDark ? 'rgba(255,255,255,0.45)' : '#94a3b8';
  const textColor = isDark ? 'rgba(255,255,255,0.85)' : '#1e293b';
  const accentColor = isDark ? 'rgba(99,102,241,0.8)' : '#6366f1';

  const actionStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 20px',
    cursor: 'pointer',
    fontSize: '14px',
    color: textColor,
    transition: 'background-color 0.15s ease',
  };
  const hoverIn = (e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc'; };
  const hoverOut = (e) => { e.currentTarget.style.backgroundColor = 'transparent'; };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      {/* Item info header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '20px 20px 16px',
        borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#f1f5f9'}`,
      }}>
        <SitesAvatar
          name={itemType.name}
          image={itemType.image ? itemType.image.imgUrl : undefined}
          size={52}
          round={12}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontSize: '15px',
            fontWeight: 600,
            color: textColor,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
            {itemType.name}
          </div>
          <div style={{ fontSize: '12px', color: mutedColor, marginTop: '2px' }}>
            {itemType.code && <span>{itemType.code} · </span>}
            {itemType.unit}
            {itemType.category && itemType.category.name && ` · ${itemType.category.name}`}
          </div>
        </div>
        <div
          onClick={onClose}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '36px',
            borderRadius: '8px',
            cursor: 'pointer',
            color: isDark ? '#94a3b8' : '#64748b',
            flexShrink: 0,
            fontSize: '20px',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}>
          <MdClose />
        </div>
      </div>
      <DialogContent style={{ padding: '8px 0' }}>
        {enableAddToStore && (
          <div
            style={{
              ...actionStyle,
              color: added ? mutedColor : '#16a34a',
              cursor: added ? 'default' : 'pointer',
            }}
            onClick={() => { if (!added) onAdd(itemType); }}
            onMouseEnter={added ? undefined : hoverIn}
            onMouseLeave={added ? undefined : hoverOut}>
            {added
              ? <ICheck size={18} style={{ color: '#16a34a' }} />
              : <IAdd size={18} />
            }
            <span>{added ? 'Already in store' : `Add to ${store ? store.name : 'Store'}`}</span>
          </div>
        )}
        <div
          style={{ ...actionStyle, color: accentColor }}
          onClick={() => onEdit(itemType)}
          onMouseEnter={hoverIn}
          onMouseLeave={hoverOut}>
          <IEdit size={18} />
          <span>Edit Item Type</span>
        </div>
        <div
          style={{ ...actionStyle, color: isDark ? '#f87171' : '#dc2626' }}
          onClick={() => onDelete(itemType)}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.04)' : '#fef2f2'; }}
          onMouseLeave={hoverOut}>
          <IDelete size={18} />
          <span>Delete Item Type</span>
        </div>
      </DialogContent>
    </Dialog>
  );
}

ItemTypeActionsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  store: PropTypes.object,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  itemType: PropTypes.object,
  enableAddToStore: PropTypes.bool,
};

export default ItemTypeActionsDialog;
